import { get_api_path } from "services/api";
import { store } from "../store";
import { sessioned_client } from "./auth";

export async function list({ query }) {
  const url = get_api_path("slot/list", query);
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { models, meta } = response.data.result;
  return { models, meta };
};

export async function detail(slot_id) {
  const url = get_api_path("slot/detail", {}, { slot_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { model } = response.data.result;
  return { model };
};

export async function close(slot_id) {
  const url = get_api_path("slot/close", {}, { slot_id });
  const { token } = store.getState().profile;
  await sessioned_client(token).post(url);
};

export async function del(slot_id) {
  const url = get_api_path("slot/delete", {}, { slot_id });
  const { token } = store.getState().profile;
  await sessioned_client(token).delete(url);
};

export async function update(slot_id, data) {
  const url = get_api_path("slot/update", {}, { slot_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};

export async function create_activity(slot_id, data) {
  const url = get_api_path("slot/activity", {}, { slot_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};

export async function schedule(slot_id, { query }) {
  const url = get_api_path("slot/schedule", query, { slot_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { models, meta } = response.data.result;
  return { models, meta };
};

